import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';
import PartnershipTagRecipientForm from '../containers/PartnershipTagRecipientFormContainer';

const PartnershipTagsRecipientsScreen = ({ ...props }) => {
  const scrollToTop = () => {
    Logger.log('debug', `PartnershipTagsRecipientsScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <Translation>
      {(t) => (
        <div>
          <DocumentHead title={t('partnership_tags_recipients_route_list')} />
          <PartnershipTagRecipientForm />
        </div>
      )}
    </Translation>
  );
};

export default PartnershipTagsRecipientsScreen;

Logger.log('silly', `PartnershipTagsRecipientsScreen loaded.`);
